import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION;
const SERIES_SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION;
export const getSubscriptionVariantTerms = (subscription) => {
    const termsComponent = subscription.components?.find(({ componentId: id }) => id === SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.ID ||
        id === SERIES_SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.ID);
    if (!termsComponent?.content) {
        return { minimum_orders: 0, binding_period_days: 0 };
    }
    if (termsComponent?.content?.__typename !== "ContentChunkContent")
        throw new Error(`Terms is not of type content chunk - Sku ${subscription?.sku}`);
    if (termsComponent.content.chunks.length === 0) {
        return { minimum_orders: 0, binding_period_days: 0 };
    }
    return termsComponent.content.chunks.flatMap((chunk) => {
        return chunk.reduce((acc, { componentId: id, content }) => {
            if ((id === SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.MINIMUM_PURCHASE ||
                id ===
                    SERIES_SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.MINIMUM_PURCHASE) &&
                content?.__typename === "NumericContent")
                return { ...acc, minimum_orders: content.number };
            if ((id === SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.BINDING_PERIOD ||
                id === SERIES_SUBSCRIPTION_IDS.VARIANT.OBLIGATIONS.BINDING_TIME) &&
                content?.__typename === "NumericContent") {
                return { ...acc, binding_period_days: content.number };
            }
            return acc;
        }, {
            minimum_orders: 0,
            binding_period_days: 0,
        });
    })[0];
};
